// extracted by mini-css-extract-plugin
export default {"root":"EnvironmentStatusBar_root__VH9+-"};